import React from "react";
import ProgressBar from "cc-ss-components/ProgressBar";

/** 70% progress */
export default function Example70Percent() {
    return <ProgressBar percent={70} width={150} />
}


// WEBPACK FOOTER //
// ./src/docs/examples/ProgressBar/Example70Percent.js